/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CatalogueLookupParams,
  CatalogueSearchParams,
  CatalogueTokenMatches,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Resolve the catalogue items a text names inline
 */
export const catalogueLookup = (
    params: MaybeRefOrGetter<CatalogueLookupParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CatalogueTokenMatches>(
      {url: `/catalogue/lookup`, method: 'GET',
        params, signal
    },
      );
    }




export const getCatalogueLookupQueryKey = (params?: MaybeRefOrGetter<CatalogueLookupParams>,) => {
    return [
    'catalogue','lookup', ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogueLookupQueryOptions = <TData = Awaited<ReturnType<typeof catalogueLookup>>, TError = ErrorType<SchemaValidationErrorResponse>>(params: MaybeRefOrGetter<CatalogueLookupParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogueLookup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCatalogueLookupQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogueLookup>>> = ({ signal }) => catalogueLookup(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogueLookup>>, TError, TData>
}

export type CatalogueLookupQueryResult = NonNullable<Awaited<ReturnType<typeof catalogueLookup>>>
export type CatalogueLookupQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Resolve the catalogue items a text names inline
 */

export function useCatalogueLookup<TData = Awaited<ReturnType<typeof catalogueLookup>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params: MaybeRefOrGetter<CatalogueLookupParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogueLookup>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogueLookupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search the catalogue for an item to name inline
 */
export const catalogueSearch = (
    params: MaybeRefOrGetter<CatalogueSearchParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<CatalogueTokenMatches>(
      {url: `/catalogue/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getCatalogueSearchQueryKey = (params?: MaybeRefOrGetter<CatalogueSearchParams>,) => {
    return [
    'catalogue','search', ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogueSearchQueryOptions = <TData = Awaited<ReturnType<typeof catalogueSearch>>, TError = ErrorType<SchemaValidationErrorResponse>>(params: MaybeRefOrGetter<CatalogueSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogueSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCatalogueSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogueSearch>>> = ({ signal }) => catalogueSearch(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogueSearch>>, TError, TData>
}

export type CatalogueSearchQueryResult = NonNullable<Awaited<ReturnType<typeof catalogueSearch>>>
export type CatalogueSearchQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search the catalogue for an item to name inline
 */

export function useCatalogueSearch<TData = Awaited<ReturnType<typeof catalogueSearch>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params: MaybeRefOrGetter<CatalogueSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogueSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogueSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






